import sanitizeHtml, { type AllowedAttribute } from 'sanitize-html';

const ALLOWED_TAGS = [...sanitizeHtml.defaults.allowedTags, 'img'];
const GENERIC_ALLOWED_ATTRIBUTES = ['style', 'title'];

export default function sanitizer(html: string): string {
  return sanitizeHtml(html, {
    allowedTags: ALLOWED_TAGS,
    allowedAttributes: {
      ...ALLOWED_TAGS.reduce<Record<string, AllowedAttribute[]>>((res, tag) => {
        res[tag] = [...GENERIC_ALLOWED_ATTRIBUTES];
        return res;
      }, {}),
      img: ['src', 'srcset', 'alt', 'width', 'height', ...GENERIC_ALLOWED_ATTRIBUTES],
      table: ['width', ...GENERIC_ALLOWED_ATTRIBUTES],
      td: ['width', ...GENERIC_ALLOWED_ATTRIBUTES],
      a: ['href', 'target', ...GENERIC_ALLOWED_ATTRIBUTES],
    },
  });
}
